(function ($, Drupal, drupalSettings) {
  'use strict';

  // Überschriften, die AnchorJS mit einem Sprungmarken-Link versehen soll.
  // Gegenüber dem AnchorJS-Default ("h2, h3, h4, h5, h6") sind zwei Fälle
  // ausgenommen, weil deren Anker-Links zusätzliche Tabstopps erzeugen,
  // die per Tastatur nicht sinnvoll bedienbar sind:
  // - Überschriften innerhalb von Formularen (z. B. Webform-Sections):
  //   Der Anker unterbricht den Formularfluss zwischen zwei Feldern.
  // - visuell versteckte Überschriften (.visually-hidden, z. B. Block-Titel
  //   der Navigation): Der Anker bleibt auch bei Fokus unsichtbar.
  var ANCHOR_SELECTOR = ':is(h2, h3, h4, h5, h6):not(form *):not(.visually-hidden)';

  /**
   * Ermittelt, ob ein angemeldeter Benutzer die Seite betrachtet.
   *
   * drupalSettings.user.uid wird von hook_js_settings_alter() (User-Modul)
   * gesetzt, damit die Auswertung clientseitig und damit render-cache-neutral
   * erfolgen kann. Je nach Kontext kommt der Wert als Zahl oder als String an,
   * deshalb wird über Number() normalisiert statt strikt gegen 0 zu vergleichen.
   *
   * @return {boolean}
   */
  function isAuthenticated() {
    var uid = drupalSettings.user ? drupalSettings.user.uid : 0;

    return Number(uid) > 0;
  }

  Drupal.behaviors.anchorjs_init = {
    attach: function (context, settings) {
      var authenticated = isAuthenticated();

      // Body-Klassen unabhängig vom Kontext setzen: Bei Ajax-Requests ist
      // context ein Fragment, in dem kein <body> enthalten ist.
      $(document.body)
        .toggleClass('user-anonymous', !authenticated)
        .toggleClass('user-authenticated', authenticated);

      // Defensive check
      if (typeof anchors === 'undefined' || typeof anchors.add !== 'function') {
        console.warn('AnchorJS wurde noch nicht geladen.');

        return;
      }

      // Der AnchorJS-Default für das Accessible Name ist das englische
      // "Anchor" – auf einer Seite mit lang="de" unbrauchbar.
      anchors.options.ariaLabel = 'Link zu diesem Abschnitt';
      anchors.add(ANCHOR_SELECTOR);

      // Für anonyme Besucher wird der sichtbare Anker-Link wieder entfernt: Er
      // ist ein Redaktions-Werkzeug und erzeugt sonst zusätzliche Tabstopps in
      // der Tastaturnavigation. anchors.remove() löscht ausschließlich das
      // <a class="anchorjs-link">-Element – die von AnchorJS auf der
      // Überschrift erzeugte id bleibt bestehen, damit Deep-Links auf
      // Abschnitte weiterhin für alle funktionieren.
      if (!authenticated) {
        anchors.remove(ANCHOR_SELECTOR);
      }
    }
  };
})(jQuery, Drupal, drupalSettings);
